import { render, staticRenderFns } from "./AreaDoAssociadoConfirmaCadastro.vue?vue&type=template&id=56deae23&"
import script from "./AreaDoAssociadoConfirmaCadastro.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoConfirmaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardActions,VCardText,VIcon})
